import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'
import { isEqual } from 'lodash'

export const useInboxFiltersStore = defineStore('inboxFilters', () => {
  const noteType = ref<string | number | null>(null)
  const tags = ref<string[]>([])
  const authors = ref<string[]>([])
  const searchTerm = ref<string>('')
  const lastChanged = ref<number>(Date.now())
  const receivedInitialValues = ref<boolean>(false)
  const anyFilterPresent = computed<boolean>(() => {
    return (
      noteType.value !== null ||
      tags.value.length > 0 ||
      authors.value.length > 0 ||
      searchTerm.value.length > 0
    )
  })

  function clearFilters(): void {
    noteType.value = null
    tags.value = []
    authors.value = []
    searchTerm.value = ''
    lastChanged.value = Date.now()
  }

  function receiveFilters(
    initialNoteType: string | number | null = null,
    initialTags: string[] = [],
    initialAuthors: string[] = [],
    initialSearchTerm: string = ''
  ): void {
    noteType.value = initialNoteType
    tags.value = initialTags
    authors.value = initialAuthors
    searchTerm.value = initialSearchTerm
    receivedInitialValues.value = true
    lastChanged.value = Date.now()
  }

  function updateLastChange(): void {
    if (receivedInitialValues.value) {
      lastChanged.value = Date.now()
    }
  }

  watch(searchTerm, updateLastChange)
  watch(
    authors,
    (value, oldValue) => {
      if (!isEqual(value, oldValue)) {
        updateLastChange()
      }
    },
    { deep: true }
  )
  watch(
    tags,
    (value, oldValue) => {
      if (!isEqual(value, oldValue)) {
        updateLastChange()
      }
    },
    { deep: true }
  )
  watch(noteType, updateLastChange)

  return {
    anyFilterPresent,
    noteType,
    tags,
    authors,
    searchTerm,
    lastChanged,
    receivedInitialValues,
    clearFilters,
    receiveFilters,
  }
})
